
(function () {
  'use strict';

  var FALLBACK_COLORS = [
    'A1 - White', 'B1 - Less White', 'B2 - Grey Tint', 'A2 - Slate Grey',
    'B3 - Focus Grey', 'A3 - Fossil Gray', 'B4 - Stone Grey', 'A4 - Lunar Gray',
    'B5 - Fashion Grey', 'B6 - Charcoal', 'B7 - Smoke Grey', 'A5 - Dove Grey',
    'A6 - Neutral Grey', 'B8 - Thunder Grey', 'A7 - Cyan Grey', 'A8 - Jet Black',
    'B9 - Black', 'B10 - Dave Gray', 'B11 - Storm Grey', 'B12 - TV Grey',
    'B13 - Studio Grey', 'A9 - Dull Aluminum', 'A10 - Morning Mist',
    'B15 - Soft Yellow', 'A11 - Fawn', 'A12 - Ivorine', 'A52 - Cream',
    'B16 - Lemonade', 'A13 - Aspen', 'A14 - Sunshine', 'B17 - Canary',
    'B18 - Sand', 'A15 - Buff', 'A16 - Forsythia Yellow', 'B19 - Deep Yellow',
    'A17 - Yellow-Orange', 'B20 - Marmalade', 'B21 - Bone', 'A18 - Snow',
    'A19 - Wheat', 'B23 - Almond', 'B24 - Autumn', 'A20 - Pongee',
    'B25 - Eggnog', 'B26 - Light Beige', 'B27 - Pecan', 'B28 - Mocha',
    'A21 - Dark Beige', 'B29 - Cocoa', 'A22 - Nutmeg', 'A23 - Coco Brown',
    'B30 - Chestnut', 'B31 - Sienna', 'A24 - Spice', 'B32 - Orange',
    'A25 - Ginger', 'B33 - Tangelo', 'B34 - Redwood', 'A26 - Bright Orange',
    'A27 - Scarlet', 'B35 - Primary Red', 'A28 - Flame', 'B36 - Crimson',
    'A29 - Plum', 'A30 - Brick', 'B37 - Rustic', 'B38 - Ruby',
    'A31 - Watermelon', 'B39 - Flamingo', 'B40 - Coral', 'A32 - Carnation Pink',
    'A33 - Mardi Gras', 'B41 - Tulip', 'A34 - Grape', 'B42 - Deep Plum',
    'B43 - Orchid', 'A35 - Thistle', 'A36 - Deep Purple', 'B44 - Purple',
    'B45 - Studio Blue', 'A37 - Royal Blue', 'B46 - Blue Jay', 'A38 - Nassau',
    'A39 - Blue Lake', 'A40 - Marine Blue', 'B48 - Gulf Blue', 'B49 - Blue Jean',
    'B50 - Ultramarine', 'A41 - Light Blue', 'A42 - Wedgewood', 'A43 - Deep Blue',
    'B51 - Blue Mist', 'A44 - Sky Blue', 'A45 - Alpine', 'B53 - Baby Blue',
    'B54 - Cyan Blue', 'A46 - Spruce', 'B55 - Teal', 'B56 - Olive Green',
    'A47 - Leaf', 'B57 - Sea Green', 'A48 - Tropical Green', 'B58 - Mint Green',
    'A49 - Apple', 'B59 - Tech Green', 'A50 - Stinger', 'B60 - Holly',
    'A51 - Deep Green', 'B61 - Evergreen'
  ];

  var FALLBACK_HEX = {
    'White':          '#ffffff', 'Less White':     '#f8f8f8', 'Grey Tint':       '#e8e8e8',
    'Slate Grey':     '#c1bfc0', 'Focus Grey':     '#b0b0b0', 'Fossil Gray':     '#b0b4b5',
    'Stone Grey':     '#a0a0a0', 'Lunar Gray':     '#929598', 'Fashion Grey':    '#909294',
    'Charcoal':       '#646b6b', 'Smoke Grey':     '#707175', 'Dove Grey':       '#606266',
    'Neutral Grey':   '#565d5d', 'Thunder Grey':   '#595c59', 'Cyan Grey':       '#4a5557',
    'Jet Black':      '#424142', 'Black':          '#000000', 'Dave Gray':       '#847d7b',
    'Storm Grey':     '#6b6d70', 'TV Grey':        '#b6aea8', 'Studio Grey':     '#bdbdb1',
    'Dull Aluminum':  '#c8c8c8', 'Morning Mist':   '#dcdcdc', 'Soft Yellow':     '#fff8dc',
    'Fawn':           '#fff5c0', 'Ivorine':        '#fff0ba', 'Cream':           '#fff39d',
    'Lemonade':       '#fdf69e', 'Aspen':          '#fff227', 'Sunshine':        '#ffed00',
    'Canary':         '#fddd44', 'Sand':           '#f4e4c1', 'Buff':            '#ffca43',
    'Forsythia Yellow': '#ffc72c', 'Deep Yellow':  '#fdbb33', 'Yellow-Orange':   '#ffa800',
    'Marmalade':      '#ffa300', 'Bone':           '#f6eddd', 'Snow':            '#f1ead8',
    'Wheat':          '#f5c280', 'Almond':         '#e3b488', 'Autumn':          '#e4ae80',
    'Pongee':         '#e4a768', 'Eggnog':         '#e6ceb9', 'Light Beige':     '#deba9b',
    'Pecan':          '#caab96', 'Mocha':          '#bf9472', 'Dark Beige':      '#b98b61',
    'Cocoa':          '#936242', 'Nutmeg':         '#8d4c1b', 'Coco Brown':      '#582e16',
    'Chestnut':       '#753d2b', 'Sienna':         '#a0522d', 'Spice':           '#8b4513',
    'Orange':         '#e96f22', 'Ginger':         '#d66540', 'Tangelo':         '#e24a10',
    'Redwood':        '#ea795b', 'Bright Orange':  '#ff461a', 'Scarlet':         '#ed2321',
    'Primary Red':    '#d12330', 'Flame':          '#e25822', 'Crimson':         '#942d4b',
    'Plum':           '#9f405b', 'Brick':          '#995151', 'Rustic':          '#8b3a3a',
    'Ruby':           '#aa0114', 'Watermelon':     '#fc6c85', 'Flamingo':        '#fc8eac',
    'Coral':          '#f9b3bb', 'Carnation Pink': '#ff9aac', 'Mardi Gras':      '#ff4779',
    'Tulip':          '#f26399', 'Grape':          '#6f2da8', 'Deep Plum':       '#512888',
    'Orchid':         '#da70d6', 'Thistle':        '#d8bfd8', 'Deep Purple':     '#663399',
    'Purple':         '#800080', 'Studio Blue':    '#4682b4', 'Royal Blue':      '#0033a0',
    'Blue Jay':       '#009fe0', 'Nassau':         '#004b87', 'Blue Lake':       '#0078ce',
    'Marine Blue':    '#2269a7', 'Gulf Blue':      '#4c87b3', 'Blue Jean':       '#496a8c',
    'Ultramarine':    '#4166f5', 'Light Blue':     '#77b9cf', 'Wedgewood':       '#5e9dc8',
    'Deep Blue':      '#253952', 'Blue Mist':      '#89cce2', 'Sky Blue':        '#87ceeb',
    'Alpine':         '#25d4d7', 'Baby Blue':      '#5cc4c3', 'Cyan Blue':       '#00bfff',
    'Spruce':         '#499080', 'Teal':           '#007771', 'Olive Green':     '#857f5a',
    'Leaf':           '#656933', 'Sea Green':      '#bdba8f', 'Tropical Green':  '#b2cd70',
    'Mint Green':     '#9ed88b', 'Apple':          '#57cb68', 'Tech Green':      '#58bc74',
    'Stinger':        '#80ba27', 'Holly':          '#029255', 'Deep Green':      '#016147',
    'Evergreen':      '#004524'
  };

  var BK_CAT = (window.BK_CATALOGUE && window.BK_CATALOGUE.length) ? window.BK_CATALOGUE : null;
  var COLORS, COLOR_HEX;
  if (BK_CAT) {
    COLORS = BK_CAT.map(function (c) { return c.code + ' - ' + c.name; });
    COLOR_HEX = {};
    BK_CAT.forEach(function (c) { COLOR_HEX[c.name] = c.hex; });
  } else {
    COLORS = FALLBACK_COLORS;
    COLOR_HEX = FALLBACK_HEX;
  }

  var LIGHTING_IMAGES = {
    'Basic Lighting':     'https://cdn.shopify.com/s/files/1/1964/8565/files/corporate-headshot-basic-lighting-preview.png?v=1781313775',
    'Gradient Lighting':  'https://cdn.shopify.com/s/files/1/1964/8565/files/corporate-headshot-gradient-lighting-preview.png?v=1781313775',
    'Executive Lighting': 'https://cdn.shopify.com/s/files/1/1964/8565/files/corporate-headshot-executive-lighting-preview.png?v=1781313775',
    'Innovator Lighting': 'https://cdn.shopify.com/s/files/1/1964/8565/files/corporate-headshot-innovator-lighting-preview.png?v=1781313775',
    'Signature Lighting': 'https://cdn.shopify.com/s/files/1/1964/8565/files/corporate-headshot-signature-lighting-preview.png?v=1781313775',
    'Neon Lighting':      'https://cdn.shopify.com/s/files/1/1964/8565/files/corporate-headshot-neon-lighting-preview.png?v=1781313775'
  };
  var LIGHTING_ALT = {
    'Basic Lighting':     'Preview of corporate headshot with basic lighting on selected backdrop colour',
    'Gradient Lighting':  'Preview of corporate headshot with gradient lighting on selected backdrop colour',
    'Executive Lighting': 'Preview of corporate headshot with executive lighting on selected backdrop colour',
    'Innovator Lighting': 'Preview of corporate headshot with innovator lighting on selected backdrop colour',
    'Signature Lighting': 'Preview of corporate headshot with signature lighting on selected backdrop colour',
    'Neon Lighting':      'Preview of corporate headshot with neon lighting on selected backdrop colour'
  };
  var DEFAULT_PREVIEW_IMAGE = LIGHTING_IMAGES['Basic Lighting'];
  var DEFAULT_PREVIEW_ALT   = LIGHTING_ALT['Basic Lighting'];

  var COLOR_FAMILY = {
    'White': 'white neutral',
    'Less White': 'white neutral',
    'Grey Tint': 'grey gray neutral light',
    'Slate Grey': 'grey gray neutral',
    'Focus Grey': 'grey gray neutral',
    'Fossil Gray': 'grey gray neutral',
    'Stone Grey': 'grey gray neutral',
    'Lunar Gray': 'grey gray neutral',
    'Fashion Grey': 'grey gray neutral',
    'Charcoal': 'grey gray dark',
    'Smoke Grey': 'grey gray',
    'Dove Grey': 'grey gray',
    'Neutral Grey': 'grey gray neutral',
    'Thunder Grey': 'grey gray dark',
    'Cyan Grey': 'grey gray',
    'Jet Black': 'black dark',
    'Black': 'black dark',
    'Dave Gray': 'grey gray',
    'Storm Grey': 'grey gray',
    'TV Grey': 'grey gray',
    'Studio Grey': 'grey gray',
    'Dull Aluminum': 'grey gray silver',
    'Morning Mist': 'grey gray light',
    'Soft Yellow': 'yellow light pastel',
    'Fawn': 'yellow tan',
    'Ivorine': 'yellow ivory cream',
    'Cream': 'yellow cream',
    'Lemonade': 'yellow',
    'Aspen': 'yellow bright',
    'Sunshine': 'yellow bright',
    'Canary': 'yellow',
    'Sand': 'beige tan neutral',
    'Buff': 'yellow orange',
    'Forsythia Yellow': 'yellow',
    'Deep Yellow': 'yellow',
    'Yellow-Orange': 'yellow orange',
    'Marmalade': 'orange yellow',
    'Bone': 'beige cream neutral',
    'Snow': 'beige white neutral',
    'Wheat': 'beige tan',
    'Almond': 'beige tan neutral',
    'Autumn': 'beige tan orange',
    'Pongee': 'beige tan',
    'Eggnog': 'beige cream',
    'Light Beige': 'beige tan',
    'Pecan': 'beige brown',
    'Mocha': 'beige brown',
    'Dark Beige': 'beige tan brown',
    'Cocoa': 'brown',
    'Nutmeg': 'brown',
    'Coco Brown': 'brown dark',
    'Chestnut': 'brown',
    'Sienna': 'brown orange red',
    'Spice': 'brown orange',
    'Orange': 'orange',
    'Ginger': 'orange',
    'Tangelo': 'orange',
    'Redwood': 'red orange',
    'Bright Orange': 'orange bright',
    'Scarlet': 'red',
    'Primary Red': 'red',
    'Flame': 'red orange',
    'Crimson': 'red dark',
    'Plum': 'purple red dark',
    'Brick': 'red brown',
    'Rustic': 'red brown',
    'Ruby': 'red dark',
    'Watermelon': 'pink red',
    'Flamingo': 'pink',
    'Coral': 'pink orange',
    'Carnation Pink': 'pink',
    'Mardi Gras': 'pink',
    'Tulip': 'pink',
    'Grape': 'purple',
    'Deep Plum': 'purple dark',
    'Orchid': 'purple pink',
    'Thistle': 'purple light',
    'Deep Purple': 'purple dark',
    'Purple': 'purple',
    'Studio Blue': 'blue',
    'Royal Blue': 'blue',
    'Blue Jay': 'blue',
    'Nassau': 'blue dark',
    'Blue Lake': 'blue',
    'Marine Blue': 'blue',
    'Gulf Blue': 'blue',
    'Blue Jean': 'blue',
    'Ultramarine': 'blue',
    'Light Blue': 'blue light',
    'Wedgewood': 'blue',
    'Deep Blue': 'blue dark navy',
    'Blue Mist': 'blue light',
    'Sky Blue': 'blue light',
    'Alpine': 'blue teal',
    'Baby Blue': 'blue light',
    'Cyan Blue': 'blue cyan',
    'Spruce': 'green teal',
    'Teal': 'green teal blue',
    'Olive Green': 'green',
    'Leaf': 'green',
    'Sea Green': 'green',
    'Tropical Green': 'green',
    'Mint Green': 'green light',
    'Apple': 'green',
    'Tech Green': 'green',
    'Stinger': 'green',
    'Holly': 'green dark',
    'Deep Green': 'green dark',
    'Evergreen': 'green dark'
  };

  var isModalBuilt  = false;
  var currentLine   = null;
  var currentQty    = 1;
  var selectedColor = null;
  var isProcessing  = false;
  var selectedOptEl = null;

  var currentMode    = 'cart';
  var onConfirmCb    = null;
  var lockedColorFull = null;

  var refs = {};

  function buildModal() {
    if (isModalBuilt) return;
    isModalBuilt = true;

    var overlay = document.createElement('div');
    overlay.id = 'backdrop-modal-overlay';
    overlay.className = 'bsm';

    var swatchesHTML = COLORS.map(function (color) {
      var parts = color.split(' - ');
      var code  = parts.length > 1 ? parts[0] : '';
      var name  = parts.length > 1 ? parts[1] : color;
      return (
        '<button type="button" class="bsm__sw" data-color-full="' + color + '" style="--sw:' + (COLOR_HEX[name] || '#cccccc') + '">' +
          '<i></i><span class="bsm__sw__txt"><span class="bsm__sw__code">' + code + '</span><u>' + name + '</u></span>' +
        '</button>'
      );
    }).join('');

    overlay.innerHTML =
      '<div class="bsm__overlay" data-bsm-cancel></div>' +
      '<div class="bsm__panel" role="dialog" aria-modal="true" aria-label="Select your backdrop colour">' +
        '<button class="bsm__x" type="button" data-bsm-cancel aria-label="Close">' +
          '<svg aria-hidden="true" focusable="false" role="presentation" class="icon-close" viewBox="0 0 256 256"><circle cx="128" cy="128" r="96" style="fill:none;stroke:currentColor;stroke-width:1.25;vector-effect:non-scaling-stroke"/><path d="M93 93 L163 163 M163 93 L93 163" style="fill:none;stroke:currentColor;stroke-width:1.25;stroke-linecap:round;vector-effect:non-scaling-stroke"/></svg>' +
        '</button>' +
        '<div class="bsm__preview">' +
          '<span class="bsm__lt" data-bsm-lt>Basic lighting \u00b7 live preview</span>' +
          '<div class="bsm__frame" data-bsm-frame>' +
            '<img class="bsm__img" data-bsm-img src="' + DEFAULT_PREVIEW_IMAGE + '" alt="' + DEFAULT_PREVIEW_ALT + '">' +
          '</div>' +
          '<span class="bsm__cap" data-bsm-cap>Select a colour to preview</span>' +
        '</div>' +
        '<div class="bsm__side">' +
          '<div class="bsm__head"><b>Select Your Backdrop Colour</b>' +
            '<a class="bsm__gallery bsm__gallery--head" href="/pages/backdrops" target="_blank" rel="noopener">View Backdrop Gallery &rarr;</a>' +
            '<span class="bsm__sub bsm__sub--d">100+ colours \u00b7 hover to preview, click to select</span>' +
            '<span class="bsm__sub bsm__sub--m">100+ colours \u00b7 tap to select</span></div>' +
          '<input type="text" class="bsm__search" data-bsm-search placeholder="Search by code or name (e.g. A37, Blue)" autocomplete="off">' +
          '<div class="bsm__grid" data-bsm-grid>' + swatchesHTML + '</div>' +
          '<div class="bsm__foot">' +
            '<span class="bsm__btns">' +
              '<button type="button" class="bsm__cancel" data-bsm-cancel>Cancel</button>' +
              '<button type="button" class="bsm__confirm" data-bsm-confirm disabled>Confirm Selection</button>' +
            '</span>' +
          '</div>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);

    refs.overlay        = overlay;
    refs.confirmBtn     = overlay.querySelector('[data-bsm-confirm]');
    refs.searchInput    = overlay.querySelector('[data-bsm-search]');
    refs.grid           = overlay.querySelector('[data-bsm-grid]');
    refs.frame          = overlay.querySelector('[data-bsm-frame]');
    refs.previewImg     = overlay.querySelector('[data-bsm-img]');
    refs.previewCaption = overlay.querySelector('[data-bsm-cap]');
    refs.lt             = overlay.querySelector('[data-bsm-lt]');

    refs.searchInput.addEventListener('input', function () {
      var q = this.value.toLowerCase().trim();
      refs.grid.querySelectorAll('.bsm__sw').forEach(function (opt) {
        if (!q) { opt.style.display = ''; return; }
        var full   = opt.getAttribute('data-color-full') || '';
        var name   = full.split(' - ')[1] || full;
        var family = COLOR_FAMILY[name] || '';
        var haystack = (full + ' ' + family).toLowerCase();
        opt.style.display = haystack.indexOf(q) !== -1 ? '' : 'none';
      });
    });

    refs.grid.addEventListener('click', function (e) {
      var opt = e.target.closest('.bsm__sw');
      if (opt) selectColor(opt.getAttribute('data-color-full'));
    });

    var swTouchMoved = false;
    refs.grid.addEventListener('touchstart', function () { swTouchMoved = false; }, { passive: true });
    refs.grid.addEventListener('touchend', function (e) {
      if (swTouchMoved) return;
      var opt = e.target.closest('.bsm__sw');
      if (opt) { e.preventDefault(); selectColor(opt.getAttribute('data-color-full')); }
    }, { passive: false });

    refs.grid.addEventListener('mouseover', function (e) {
      var opt = e.target.closest('.bsm__sw');
      if (opt) setPreviewColour(opt.getAttribute('data-color-full'));
    });
    refs.grid.addEventListener('mouseleave', function () {
      if (lockedColorFull) setPreviewColour(lockedColorFull); else resetPreview();
    });

    overlay.addEventListener('click', function (e) {
      if (e.target.closest('[data-bsm-confirm]')) { handleConfirm(); return; }
      if (e.target.closest('[data-bsm-cancel]'))  { closeModal();   return; }
    });

    overlay.addEventListener('mousedown', function (e) {
      e.stopPropagation();
    });

    if (refs.grid) {
      refs.grid.addEventListener('touchmove', function (e) {
        swTouchMoved = true;
        e.stopPropagation();
      }, { passive: true });
    }

    applySwatchColors();
  }

  function setPreviewColour(colorFull) {
    if (!colorFull || !refs.frame) return;
    var name = colorFull.split(' - ').pop();
    var hex = COLOR_HEX[name];
    if (hex) refs.frame.style.backgroundColor = hex;
    if (refs.previewCaption) refs.previewCaption.innerHTML = '<strong>' + colorFull + '</strong>';
  }
  function resetPreview() {
    if (refs.frame) refs.frame.style.backgroundColor = '#eeeeee';
    if (refs.previewCaption) refs.previewCaption.textContent = 'Select a colour to preview';
  }

  function openPicker(opts) {
    opts = opts || {};
    buildModal();

    currentMode   = opts.mode || 'cart';
    currentLine   = (opts.line != null) ? opts.line : null;
    currentQty    = opts.qty || 1;
    onConfirmCb   = (typeof opts.onConfirm === 'function') ? opts.onConfirm : null;
    selectedColor = null;
    lockedColorFull = null;
    isProcessing  = false;

    var lighting = opts.lighting || '';
    var previewImg = refs.previewImg;
    if (previewImg) {
      var imgUrl = (lighting && LIGHTING_IMAGES[lighting]) || DEFAULT_PREVIEW_IMAGE;
      var imgAlt = (lighting && LIGHTING_ALT[lighting])    || DEFAULT_PREVIEW_ALT;
      if (previewImg.src !== imgUrl) {
        previewImg.classList.add('bsm__img--loading');
        previewImg.addEventListener('load', function onLoad() {
          previewImg.classList.remove('bsm__img--loading');
          previewImg.removeEventListener('load', onLoad);
        });
        previewImg.addEventListener('error', function onErr() {
          previewImg.classList.remove('bsm__img--loading');
          previewImg.removeEventListener('error', onErr);
        });
        previewImg.src = imgUrl;
      }
      previewImg.alt = imgAlt;
    }
    if (refs.frame) refs.frame.classList.toggle('bsm__frame--gradient', lighting === 'Gradient Lighting');
    if (refs.lt) refs.lt.textContent = (lighting ? lighting.replace(' Lighting', '') : 'Basic') + ' lighting · live preview';

    if (selectedOptEl) { selectedOptEl.classList.remove('is-lock'); selectedOptEl = null; }
    refs.grid.querySelectorAll('.bsm__sw').forEach(function (opt) { opt.style.display = ''; });
    if (refs.searchInput) refs.searchInput.value = '';
    resetPreview();

    var current = opts.current || null;
    if (current) {
      var existing = refs.grid.querySelector('.bsm__sw[data-color-full="' + current + '"]');
      if (existing) {
        existing.classList.add('is-lock');
        selectedColor = current; selectedOptEl = existing; lockedColorFull = current;
        setPreviewColour(current);
      }
    }

    setConfirmState(!!selectedColor, false);

    if (refs.overlay) refs.overlay.style.display = 'flex';
    document.body.classList.add('backdrop-modal-open');

    if (refs.grid) {
      if (selectedOptEl) {
        var targetTop = selectedOptEl.offsetTop - (refs.grid.clientHeight / 2) + (selectedOptEl.clientHeight / 2);
        refs.grid.scrollTop = Math.max(0, targetTop);
      } else {
        refs.grid.scrollTop = 0;
      }
    }
  }

  function openModal(line, qty, currentColour, lighting) {
    openPicker({ mode: 'cart', line: line, qty: qty, current: currentColour, lighting: lighting });
  }

  function closeModal() {
    if (refs.overlay) refs.overlay.style.display = 'none';
    document.body.classList.remove('backdrop-modal-open');
    isProcessing = false;
  }

  function selectColor(colorFull) {
    selectedColor = colorFull;
    lockedColorFull = colorFull;
    if (selectedOptEl) selectedOptEl.classList.remove('is-lock');
    var newOpt = refs.grid.querySelector('.bsm__sw[data-color-full="' + colorFull + '"]');
    if (newOpt) {
      newOpt.classList.add('is-lock');
      selectedOptEl = newOpt;
    } else {
      selectedOptEl = null;
    }
    setPreviewColour(colorFull);
    setConfirmState(true, false);
  }

  function setConfirmState(enabled, loading) {
    if (!refs.confirmBtn) return;
    refs.confirmBtn.disabled = !enabled || loading;
    refs.confirmBtn.textContent = loading ? 'Updating\u2026' : 'Confirm Selection';
  }

  function applySwatchColors() {
    document.querySelectorAll('[data-color-name]').forEach(function (el) {
      var name = el.getAttribute('data-color-name');
      var hex  = COLOR_HEX[name];
      if (hex) el.style.background = hex;
    });
  }

  function applyBackdropPreviews() {
    document.querySelectorAll('.cart__item__backdrop-preview').forEach(function (el) {
      var colorName = el.getAttribute('data-backdrop-color-name');
      var lighting  = el.getAttribute('data-lighting');
      var colourFull = el.getAttribute('data-colour-full');
      var hex = colorName && COLOR_HEX[colorName];
      var imgUrl = (lighting && LIGHTING_IMAGES[lighting]) || DEFAULT_PREVIEW_IMAGE;
      var alt    = (lighting && LIGHTING_ALT[lighting])    || DEFAULT_PREVIEW_ALT;
      if (hex) el.style.backgroundColor = hex;
      el.classList.toggle('cart__item__backdrop-preview--gradient', lighting === 'Gradient Lighting');
      var img = el.querySelector('.cart__item__backdrop-preview-img');
      if (img) {
        if (img.getAttribute('src') !== imgUrl) img.src = imgUrl;
        img.alt = alt + (colourFull ? ' — ' + colourFull : '');
      }
    });
  }

  function applyOptimisticUI(line) {
    var selectBtn =
      document.querySelector('[data-open-backdrop-modal][data-line="' + line + '"]') ||
      document.querySelector('[data-change-backdrop-modal][data-line="' + line + '"]');
    if (!selectBtn) return null;

    var wrap = selectBtn.closest('.backdrop-select-wrap') ||
               selectBtn.closest('.backdrop-selected-wrap') ||
               selectBtn.parentElement;
    if (!wrap) return null;

    var snapshot = { parent: wrap.parentNode, placeholder: document.createComment('backdrop-optimistic'), originalHTML: wrap.outerHTML };

    var indicator = document.createElement('span');
    indicator.className = 'backdrop-optimistic-saving';
    indicator.setAttribute('data-optimistic-line', line);
    indicator.style.cssText = 'font-size:13px;color:#999;padding:6px 0;line-height:1.4;';
    indicator.innerHTML = '<svg class="spinner-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#999" viewBox="0 0 256 256"><path d="M132,32V64a4,4,0,0,1-8,0V32a4,4,0,0,1,8,0Zm41.25,54.75a4,4,0,0,0,2.83-1.18L198.71,63a4,4,0,0,0-5.66-5.66L170.43,79.92a4,4,0,0,0,2.82,6.83ZM224,124H192a4,4,0,0,0,0,8h32a4,4,0,0,0,0-8Zm-47.92,46.43a4,4,0,1,0-5.65,5.65l22.62,22.63a4,4,0,0,0,5.66-5.66ZM128,188a4,4,0,0,0-4,4v32a4,4,0,0,0,8,0V192A4,4,0,0,0,128,188ZM79.92,170.43,57.29,193.05A4,4,0,0,0,63,198.71l22.62-22.63a4,4,0,1,0-5.65-5.65ZM68,128a4,4,0,0,0-4-4H32a4,4,0,0,0,0,8H64A4,4,0,0,0,68,128ZM63,57.29A4,4,0,0,0,57.29,63L79.92,85.57a4,4,0,1,0,5.65-5.65Z"></path></svg>Applying backdrop colour\u2026';

    wrap.parentNode.replaceChild(indicator, wrap);
    return snapshot;
  }

  function revertOptimisticUI(snapshot) {
    if (!snapshot) return;
    var indicator = snapshot.parent && snapshot.parent.querySelector('[data-optimistic-line]');
    if (indicator) {
      var tmp = document.createElement('div');
      tmp.innerHTML = snapshot.originalHTML;
      var original = tmp.firstElementChild;
      if (original) indicator.parentNode.replaceChild(original, indicator);
    }
  }

  function saveBackdropProperty(line, qty, colour) {
    var formData = new FormData();
    formData.append('line', line);
    formData.append('quantity', qty || 1);
    formData.append('properties[Backdrop Colour]', colour || '');

    return fetch('/cart/change.js', { method: 'POST', body: formData })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart change failed ' + r.status);
        return r.json();
      });
  }

  function refreshCartDrawer(knownItemCount) {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));

    var handled = false;
    function onCartRefreshed() {
      if (handled) return;
      handled = true;
      document.removeEventListener('theme:cart:added', onCartRefreshed);
      applySwatchColors();
      applyBackdropPreviews();
      validateCart(false);
    }
    document.addEventListener('theme:cart:added', onCartRefreshed);

    setTimeout(function () {
      onCartRefreshed();
    }, 3000);

    return Promise.resolve();
  }

  function ensureCartOpen() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var isOpen = drawer && (
      drawer.classList.contains('is-open') ||
      drawer.classList.contains('drawer--is-open') ||
      drawer.classList.contains('drawer--open')
    );
    if (!isOpen) {
      var toggle = document.querySelector('[data-cart-drawer-toggle]');
      if (toggle) toggle.click();
    }
  }

  function handleConfirm() {
    if (!selectedColor || isProcessing) return;

    if (currentMode === 'page') {
      var cb = onConfirmCb;
      closeModal();
      if (cb) cb(selectedColor);
      return;
    }

    if (!currentLine) return;

    isProcessing = true;
    setConfirmState(false, true);
    closeModal();

    var snapshot = applyOptimisticUI(currentLine);
    validateCart(false);

    var line  = currentLine;
    var qty   = currentQty;
    var color = selectedColor;

    saveBackdropProperty(line, qty, color)
      .then(function (cart) {
        return refreshCartDrawer(cart.item_count);
      })
      .catch(function (err) {
        console.error('[BackdropSelector] save error:', err);
        revertOptimisticUI(snapshot);
        validateCart(false);
        alert('Failed to save backdrop colour. Please try again.');
      })
      .then(function () {
        isProcessing = false;
        setConfirmState(false, false);
      });
  }

  function handleRemove(line, qty, btn) {
    if (isProcessing) return;
    isProcessing = true;

    if (btn) {
      btn.disabled    = true;
      btn.textContent = 'Removing\u2026';
    }

    saveBackdropProperty(line, qty, '')
      .then(function (cart) {
        return refreshCartDrawer(cart.item_count);
      })
      .catch(function (err) {
        console.error('[BackdropSelector] remove error:', err);
        if (btn) {
          btn.disabled    = false;
          btn.textContent = 'Remove';
        }
        alert('Failed to remove backdrop colour. Please try again.');
      })
      .then(function () {
        isProcessing = false;
      });
  }

  function backdropPending() {
    return document.querySelectorAll('[data-open-backdrop-modal]').length > 0;
  }

  function termsPending() {
    var cb = document.querySelector('#acceptance');
    return cb && !cb.checked;
  }

  var checkoutArmed = false;

  function validateCart(showErrors) {
    var hasErrors = backdropPending() || termsPending();
    if (showErrors && hasErrors) checkoutArmed = true;
    setTimeout(renderCheckoutState, 50);
    if (showErrors && hasErrors) shakeCheckout();
    return !hasErrors;
  }

  function renderCheckoutState() {
    var needsBackdrop = backdropPending();
    var needsTerms    = termsPending();
    var btn = document.querySelector('button[name="checkout"], .cart__checkout');
    if (!btn) return;

    if (!needsBackdrop && !needsTerms) checkoutArmed = false;

    var wrapper  = document.querySelector('[data-cart-checkout-buttons]');
    if (wrapper) wrapper.classList.remove('cart__buttons--disabled');
    var fieldset = document.querySelector('[data-cart-checkout-button]');
    if (fieldset) fieldset.removeAttribute('disabled');
    btn.removeAttribute('disabled');
    btn.classList.remove('btn--disabled');

    var intercept = btn.querySelector('[data-cart-intercept]');
    btn.classList.remove('is-intercept');
    if (intercept) intercept.hidden = true;

    var show = checkoutArmed;
    var backdropErr = document.querySelector('[data-backdrop-error-message]');
    if (backdropErr) backdropErr.hidden = !(show && needsBackdrop);
    var termsErr = document.querySelector('[data-terms-error-message]');
    if (termsErr) termsErr.hidden = !(show && needsTerms);
  }

  function shakeCheckout() {
    var btn = document.querySelector('button[name="checkout"], .cart__checkout');
    if (!btn) return;
    btn.classList.remove('is-shake'); void btn.offsetWidth; btn.classList.add('is-shake');
    setTimeout(function () { btn.classList.remove('is-shake'); }, 520);
  }

  document.addEventListener('click', function (e) {

    var selectBtn = e.target.closest('[data-open-backdrop-modal]');
    if (selectBtn) {
      e.preventDefault();
      e.stopPropagation();
      openModal(
        selectBtn.getAttribute('data-line'),
        selectBtn.getAttribute('data-line-qty') || 1,
        null,
        selectBtn.getAttribute('data-line-lighting') || ''
      );
      return;
    }

    var changeBtn = e.target.closest('[data-change-backdrop-modal]');
    if (changeBtn) {
      e.preventDefault();
      e.stopPropagation();
      openModal(
        changeBtn.getAttribute('data-line'),
        changeBtn.getAttribute('data-line-qty') || 1,
        changeBtn.getAttribute('data-current-colour') || null,
        changeBtn.getAttribute('data-line-lighting') || ''
      );
      return;
    }

    var removeBtn = e.target.closest('[data-remove-backdrop]');
    if (removeBtn && !removeBtn.disabled) {
      e.preventDefault();
      e.stopPropagation();
      var line      = removeBtn.getAttribute('data-line');
      var qty       = removeBtn.getAttribute('data-line-qty');
      if (!qty) {
        var changeEl = document.querySelector('[data-change-backdrop-modal][data-line="' + line + '"]');
        qty = changeEl ? changeEl.getAttribute('data-line-qty') : '1';
      }
      handleRemove(line, qty || 1, removeBtn);
      return;
    }

    var checkoutArea = e.target.closest(
      '[data-cart-checkout-buttons], [data-cart-checkout-button], .cart__checkout, [name="checkout"]'
    );
    if (checkoutArea && (backdropPending() || termsPending())) {
      e.preventDefault();
      e.stopPropagation();
      validateCart(true);
      return;
    }

  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute('data-cart-form')) return;
    if (!backdropPending() && !termsPending()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    validateCart(true);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  function init() {
    if (window.backdropSelectorInitialized) return;
    window.backdropSelectorInitialized = true;

    applySwatchColors();
    applyBackdropPreviews();
    validateCart(false);

    document.addEventListener('change', function (e) {
      if (e.target && e.target.id === 'acceptance') validateCart(false);
    });

    var itemsHolder =
      document.querySelector('[data-cart-drawer] [data-items-holder]') ||
      document.querySelector('[data-cart-drawer]');
    if (itemsHolder) {
      var rafPending = false;
      new MutationObserver(function () {
        if (rafPending) return;
        rafPending = true;
        requestAnimationFrame(function () {
          rafPending = false;
          applySwatchColors();
          applyBackdropPreviews();
          validateCart(false);
        });
      }).observe(itemsHolder, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.backdropSelector = {
    openPicker:   openPicker,
    openModal:    openModal,
    closeModal:   closeModal,
    validateCart: validateCart,
    refresh:      refreshCartDrawer,
    COLORS:       COLORS,
    COLOR_HEX:    COLOR_HEX,
    lightingImage: function (ltKey) { return (ltKey && LIGHTING_IMAGES[ltKey]) || DEFAULT_PREVIEW_IMAGE; }
  };

}());
